import { render, staticRenderFns } from "./AuxiliaryRegister.vue?vue&type=template&id=3c735a91&scoped=true"
import script from "./AuxiliaryRegister.vue?vue&type=script&lang=js"
export * from "./AuxiliaryRegister.vue?vue&type=script&lang=js"
import style0 from "./AuxiliaryRegister.vue?vue&type=style&index=0&id=3c735a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c735a91",
  null
  
)

export default component.exports